import { render, staticRenderFns } from "./staffPayCard.vue?vue&type=template&id=01677d42&scoped=true&"
import script from "./staffPayCard.vue?vue&type=script&lang=js&"
export * from "./staffPayCard.vue?vue&type=script&lang=js&"
import style0 from "./staffPayCard.vue?vue&type=style&index=0&id=01677d42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01677d42",
  null
  
)

export default component.exports